
import moreHorizontalRenderer from 'moreCore/UI/moreCoreCalendar/Renderers/moreCoreHorizontalRenderer';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from 'dojox/calendar/templates/LabelRenderer.html?raw';
import query from 'dojo/query';

import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import "./moreCoreHorizontalRenderer";



class moreCoreLabelRenderer extends compose(moreHorizontalRenderer) {
    [key: string]: any;

    templateString: any = template;


    updateRendering(w, h): void {
        super.updateRendering.apply(this, arguments as any);

        var itemColor: { backColor: string, textColor: string } = this.getItemColor(this.item._item);
        if (itemColor) {
            var colorBack: string = itemColor.backColor;
            var colorText: string = itemColor.textColor;

            if (colorBack && colorBack.indexOf("rgb") == -1) {
                if (colorBack.indexOf("#") == -1) colorBack = "#" + colorBack;
            }

            if (colorText && colorText.indexOf("rgb") == -1) {
                if (colorText.indexOf("#") == -1) colorText = "#" + colorText;
            }

            this.domNode.style.setProperty("--bgColor", colorBack);
            this.domNode.style.setProperty("--txtColor", colorText);


            // ob die Hexwerte nun mit oder ohne "#" kommen is uns wurscht

            let Collection: HTMLCollection = <HTMLCollection>(<any>query(".labels", this.domNode));
            for (let j = 0; j < Collection.length; j++) {

                domClass.add(Collection[j], "webcalendarHorLabel");
                //domStyle.set(Collection[j], "border-radius", "5px");
                domStyle.set(Collection[j], "background-color", colorBack);

            }

            domStyle.set(this.summaryLabel, { "color": colorText });
            domStyle.set(this.startTimeLabel, { "color": colorText });
        }
    }
    getItemColor(item): { backColor: string, textColor: string} {
        return { backColor: "#f5bf42", textColor: "#000000" }; // default colors
    }




    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }


}

export default mdsWidget(moreCoreLabelRenderer);